import { getMessageVariables } from '@chatwoot/utils';

/**
 * Generates a temporary case_id for use while composing a new conversation
 * or draft before a real conversation record exists.
 *
 * Format: `${inboxId}${customEpochTimestamp}` — always numeric.
 * Uses custom epoch starting January 1, 2026 for smaller, less predictable IDs.
 * Generate once per composer session; regenerate only if the draft resets.
 */
const CUSTOM_EPOCH = Date.parse('2026-01-01T00:00:00Z') / 1000;
const nowSince = epoch => Math.floor(Date.now() / 1000) - epoch;

export const generateTempCaseId = inboxId => {
  const inbox = String(inboxId);
  return (
    inbox + String(nowSince(CUSTOM_EPOCH)).padStart(12 - inbox.length, '0')
  );
};

/**
 * Extends the standard getMessageVariables with Lixibox-specific variables
 * that are not part of the upstream @chatwoot/utils package.
 *
 * Add new custom variables here to make them available in canned responses
 * and message templates (e.g. {{conversation.case_id}}).
 */
export const getExtendedMessageVariables = ({
  conversation = {},
  contact = {},
  inbox = {},
} = {}) => {
  const baseVariables = getMessageVariables({ conversation, contact, inbox });
  return {
    ...baseVariables,
    'conversation.case_id': conversation?.case_id ?? '',
  };
};
